export class Format {
    id: number;
    libelle: string;
    description: string;
}
